export default __webpack_public_path__ + "static/logo-big-ingeniosamente-c61db3d9dfe66cdccdcde065b713bf2b.png";